/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { ManagedUser } from './managed-user.model';
import { RulePriority } from './rx-intercept-rule.model';

export enum MidasAdminOrganizationPermissions {
  Readonly = 1,
  ReadAndWrite = 2,
}

export interface Organization {
  id: number;
  name: string;
  midasAdminOrganizationPermissions: MidasAdminOrganizationPermissions;
  createdAt: string;
  updatedAt: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: number | null;
  cartAutoLogoutTime: number;
  anytimeWasteNotificationTimePeriod: number;
  anytimeTransportNotificationTimePeriod: number;
  rxInterceptRuleNotificationTimePeriod: number;
  rxInterceptPriorityToAssay: RulePriority;
  enforceUniqueBagIdentifiers: boolean;
  alternateBinsOnORWaste: boolean;
  contactName: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
  rootUser: ManagedUser;
  accountNumber: string;
  baselineScheduleI: number;
  baselineScheduleII: number;
  baselineScheduleIII: number;
  baselineScheduleIV: number;
  baselineScheduleV: number;
  baselineNonControlled: number;
  enforceBinExpiry: boolean;
  binExpiryDays: number;
  patientRetentionLimit: number;
  orderRetentionLimit: number;
  showTestUserTransactions: boolean;
  calcCopyPaste: boolean;
  customDomain: string | null;
}
